import(/* webpackMode: "eager", webpackExports: ["ProductsCatalog"] */ "/home/deploy/proyecto/fs-negotium/apps/customer-portal/components/ProductsCatalog/index.tsx");
